import * as React from "react";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Loadable } from "../Loader";
import { usePageContext } from "./hooks";
import Footer from "../Footer";
import { FOOTER_DESKTOP_HEIGHT } from "../../constants/values";
const useStyles = makeStyles(({
  breakpoints,
  palette,
  typography
}) => ({
  container: {
    width: "100%",
    overflowY: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    },
    [breakpoints.up("sm")]: {
      height: "100%"
    }
  },
  contentContainer: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  background: ({
    backgroundOpacity
  }) => ({
    height: "100vh",
    width: "100%",
    position: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPositionX: "center",
    "&::before": {
      position: "fixed",
      backgroundColor: palette.background.image,
      content: '""',
      display: "block",
      width: "100%",
      height: "100vh",
      opacity: backgroundOpacity || palette.background.opacity,
      pointerEvents: "none"
    }
  }),
  content: {
    flex: 1,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    [breakpoints.up("sm")]: {
      minHeight: `calc(100vh - ${FOOTER_DESKTOP_HEIGHT}px - 20px)`
    }
  },
  paddingBottom: {
    [breakpoints.down("xs")]: {
      paddingBottom: typography.pxToRem(200)
    }
  }
}));

const Content = ({
  asyncDataProps,
  analytics,
  children
}) => {
  const {
    backgroundImage,
    speedDialActions,
    isFooterHidden,
    backgroundOpacity
  } = usePageContext();
  const styles = useStyles({
    backgroundOpacity
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    id: "scrollContainer"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${backgroundImage})`
    },
    className: styles.background
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.contentContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    className: clsx(styles.content, speedDialActions.length && styles.paddingBottom),
    container: true,
    alignContent: "flex-start",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loadable, {
    asyncDataProps: asyncDataProps
  }, children)), !isFooterHidden && /*#__PURE__*/React.createElement(Footer, {
    analytics: analytics
  })));
};

export default Content;